var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadScoreDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.532227,
    y: 0.00439453,
    width: 21,
    height: 24.0046,
    rx: 2,
    fill: "#B2B2B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2979 13.7959L11.5479 17.5459C11.4072 17.6865 11.2197 17.7568 11.0322 17.7568C10.8213 17.7568 10.6338 17.6865 10.4932 17.5459L6.74316 13.7959C6.43848 13.5146 6.43848 13.0225 6.74316 12.7412C7.02441 12.4365 7.5166 12.4365 7.79785 12.7412L10.2822 15.2021V8.00684C10.2822 7.6084 10.6104 7.28027 11.0088 7.28027C11.3838 7.28027 11.7822 7.6084 11.7822 8.00684V15.2021L14.2432 12.7412C14.5244 12.4365 15.0166 12.4365 15.2979 12.7412C15.6025 13.0225 15.6025 13.5146 15.2979 13.7959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadScoreDisabled);
export default __webpack_public_path__ + "static/media/DownloadScoreDisabled.2c2da48ddcfa8c2e9fc776a3b9c43c32.svg";
export { ForwardRef as ReactComponent };